import { AriaRole, FC } from 'react';

import { Grid } from '@purpur/library';

import { BlockHeader } from '../common/BlockHeader';
import { BlockSection } from '../common/Common.styles';
import { CtaData } from '../common/model';
import { BlockQuickLinkCardsContainer } from './BlockQuickLink.styles';
import { BlockQuickLinkDisplayVariant, QuickLinkCardData } from './model';
import { QuickLinkCard } from './QuickLinkCard';

type Props = {
    blockTitle?: string;
    blockCta?: CtaData;
    cards?: QuickLinkCardData[];
    displayVariant?: BlockQuickLinkDisplayVariant;
    role?: AriaRole;
    ariaLabel?: string;
    id?: string;
    dataSectionName?: string;
};

export const QuickLinkCards: FC<Props> = ({
    displayVariant,
    blockTitle,
    blockCta,
    cards,
    role,
    ariaLabel,
    id,
    dataSectionName,
}) => {
    return (
        <BlockSection
            data-section="Quick Link Block"
            data-section-name={dataSectionName || blockTitle}
            aria-label={ariaLabel}
            role={role}
            id={id}
        >
            <Grid noGap={true}>
                <BlockHeader title={blockTitle} cta={blockCta} />
                <BlockQuickLinkCardsContainer $displayVariant={displayVariant} aria-label={blockTitle || ariaLabel}>
                    {cards?.map((card) => (
                        <li key={card.id}>
                            <QuickLinkCard card={card} />
                        </li>
                    ))}
                </BlockQuickLinkCardsContainer>
            </Grid>
        </BlockSection>
    );
};
